module.exports = __webpack_public_path__ + "img/a_kochian.c094f6c9.jpg";